import { type ExcludeRelayFutureAddedValue } from '#app/types/utils.js';
import { StyledMoreIcon } from './SocialMediaLink.styles.js';
import { type SocialMediaLinkBrand } from './types.js';
import {
  ExternalLinkAltIcon,
  type IconSvgProps,
  MailSolidIcon,
  SocialAngelListIcon,
  SocialArtstationIcon,
  SocialAwwwardsIcon,
  SocialBehanceIcon,
  SocialCarbonmadeIcon,
  SocialDeviantartIcon,
  SocialDevToIcon,
  SocialDribbbleIcon,
  SocialFacebookIcon,
  SocialFiverrIcon,
  SocialFreelancerIcon,
  SocialGithubIcon,
  SocialGitlabIcon,
  SocialHashnodeIcon,
  SocialInstagramIcon,
  SocialLinkedinIcon,
  SocialMediumIcon,
  SocialMessengerIcon,
  SocialPatreonIcon,
  SocialPinterestIcon,
  SocialSoundcloudIcon,
  SocialStackOverflowIcon,
  SocialTheFwaIcon,
  SocialTiktokIcon,
  SocialTumblrIcon,
  SocialTwitchIcon,
  SocialTwitterIcon,
  SocialUpworkIcon,
  SocialVimeoIcon,
  SocialVkIcon,
  SocialWorkingNotWorkingIcon,
  SocialYoutubeIcon,
} from '@contra/icons/icons';
import { type ComponentType } from 'react';

const mapSocialBrandToExport = {
  ANGELLIST: SocialAngelListIcon,
  ARTSTATION: SocialArtstationIcon,
  AWWWARDS: SocialAwwwardsIcon,
  BEHANCE: SocialBehanceIcon,
  CARBONMADE: SocialCarbonmadeIcon,
  DEV: SocialDevToIcon,
  DEVIANTART: SocialDeviantartIcon,
  DRIBBBLE: SocialDribbbleIcon,
  EMAIL: MailSolidIcon,
  FACEBOOK: SocialFacebookIcon,
  FIVERR: SocialFiverrIcon,
  FREELANCER: SocialFreelancerIcon,
  FWA: SocialTheFwaIcon,
  GITHUB: SocialGithubIcon,
  GITLAB: SocialGitlabIcon,
  HASHNODE: SocialHashnodeIcon,
  INSTAGRAM: SocialInstagramIcon,
  LINKEDIN: SocialLinkedinIcon,
  MEDIUM: SocialMediumIcon,
  MESSENGER: SocialMessengerIcon,
  MISC: ExternalLinkAltIcon,
  MORE: StyledMoreIcon,
  PATREON: SocialPatreonIcon,
  PINTEREST: SocialPinterestIcon,
  SOUNDCLOUD: SocialSoundcloudIcon,
  STACKOVERFLOW: SocialStackOverflowIcon,
  TIKTOK: SocialTiktokIcon,
  TUMBLR: SocialTumblrIcon,
  TWITCH: SocialTwitchIcon,
  TWITTER: SocialTwitterIcon,
  undefined: ExternalLinkAltIcon,
  UPWORK: SocialUpworkIcon,
  VIMEO: SocialVimeoIcon,
  VKONTAKTE: SocialVkIcon,
  WNW: SocialWorkingNotWorkingIcon,
  // eslint-disable-next-line id-length
  X: SocialTwitterIcon,
  YOUTUBE: SocialYoutubeIcon,
};

const isSocialIconBrand = (
  brand?: string,
): brand is ExcludeRelayFutureAddedValue<SocialMediaLinkBrand> => {
  return Boolean(
    brand &&
      Object.prototype.hasOwnProperty.call(mapSocialBrandToExport, brand),
  );
};

export const getSocialIconViaBrand = (
  brand: SocialMediaLinkBrand | undefined,
): ComponentType<IconSvgProps> => {
  if (isSocialIconBrand(brand)) {
    return mapSocialBrandToExport[brand];
  }

  return mapSocialBrandToExport.MISC;
};
